const isChannelLatino = process.env.CHANNEL === 'latino';

const locales = isChannelLatino
  ? ['en', 'pt', 'es', 'default-ln']
  : ['zht', 'en', 'zh', 'ko', 'ja', 'vi', 'th', 'default-ln'];

const localesMap = locales.reduce((mapped, current) => {
  mapped[current] = current;
  return mapped;
}, {});

module.exports = {
  locales: locales,
  localesMap,
  defaultLocale: 'default-ln',
  pages: {
    '*': ['common', 'home', 'ftu', 'seo', 'goldRewards', 'pdp', 'product-card'],
    '/order/checkout': ['restaurant', 'combine', 'groupOrder', 'subscribe'],
    '/order/checkout/v1': ['restaurant', 'combine', 'groupOrder', 'subscribe'],
    'rgx:/order/detail/*': ['restaurant', 'groupOrder', 'order', 'orderSuccess', 'pdp'],
    'rgx:/(review|account/(delete-account|follow-info|notification|profile|settings|login|signup)|order/list|mkpl/vendor/)': [
      'review',
      'onboarding'
    ],
    'rgx:/(points|account/perks|/account/points/group-buy)': ['points'],
    'rgx:/(vendor|cart|product|mkpl|support)': ['vendor', 'combine', 'groupOrder', 'pdp', 'mylist'],
    'rgx:/product/*': ['pdp', 'gift-card'],
    'rgx:/order/(success|gift-card/success)/*': ['orderShare', 'orderSuccess', 'combine', 'campaigns'],
    'rgx:/order/share/*': ['orderShare', 'referral', 'onboarding'],
    'rgx:/weeebates/share/*': ['orderShare'],
    'rgx:/category/': ['combine'],
    'rgx:/add-on/*': ['combine', 'addon', 'pdp', 'common'],
    'rgx:/account/address': ['combine'],
    'rgx:/order/list': ['orderList', 'groupOrder', 'order'],
    'rgx:/campaigns/lty/*': ['campaigns'],
    'rgx:/order/today-order': ['orderList'],
    'rgx:/mkpl/vendor/*': ['vendor', 'combine', 'groupOrder', 'pdp', 'mylist', 'mkplRaffle'],
    'rgx:/campaigns/*': ['campaigns'],
    'rgx:/mkpl/group-order/*': ['groupOrder', 'vendor'],
    'rgx:/mkpl/(raffle|anniversary|christmas)/*': ['mkplRaffle'],
    'rgx:/account/my-coupons/*': ['mkplRaffle'],
    'rgx:/promotion/combine-purchase': ['groupOrder'],
    'rgx:/promotion/rewards-landing': ['points'],
    'rgx:/activity/raffle/landing': ['raffle'],
    'rgx:/account/(referral|affiliate|verify)': ['referral', 'onboarding'],
    'rgx:/topics/': ['topic'],
    'rgx:/account/(my-list|affiliate-list)/*': ['mylist'],
    'rgx:/share/(list|affiliate-list)/*': ['mylist'],
    'rgx:/account/onboarding/*': ['onboarding', 'review'],
    'rgx:/order/refund-request/*': ['order'],
    'rgx:/freebie/*': ['freebies'],
    'rgx:/brand/detail/*': ['vendor'],
    'rgx:/order/case/*': ['refund'],
    'rgx:/(account/help|help/(view/*|search|detail/*)|about)': ['helpCenter'],
    'rgx:/checkout': ['checkout', 'vendor'],
    'rgx:/order/nocart-checkout/*': ['checkout'],
    'rgx:/promotion/free-gift/*': ['promotion'],
    'rgx:/order/change-date/(list|detail/*)': ['orderList'],
    'rgx:/account/gift-card/*': ['gift-card'],
    'rgx:/order/gift-card/*': ['gift-card', 'orderSuccess'],
    'rgx:/promotion/coupon-landing': ['couponLanding'],
    'rgx:/annual-report/*': ['annualReport'],
    'rgx:/support/preheat': ['orderSuccess', 'orderShare'],
    'rgx:/order/invoice/*': ['order'],
    'rgx:/social/*': ['review'],
    'rgx:/order/dealpay/*': ['combine'],
    'rgx:/student-benefits/*': ['student'],
    'rgx:/(subscribe/*|account|cart|product/*|order/*)': ['subscribe'],
    'rgx:/search/*': ['helpCenter']
  },
  loadLocaleFrom: (lang, ns) => {
    const pathToLocales = process.env.CHANNEL === 'latino' ? 'latino-locales' : 'locales';
    return import(
      `./src/${pathToLocales}/${lang === 'default-ln' || !locales.includes(lang) ? 'en' : lang}/${ns}.json`
    ).then(m => m.default);
  }
};
